/* eslint-disable import/extensions */
/* eslint-disable max-len */
import React from 'react';
import Router from 'next/router';
import { Badge, Nav, Navbar, } from 'react-bootstrap';
import { auth } from '@/services/auth';
import { generator } from '@/helpers/utils';

export default function NavbarCrmComponent({ code, menus }) {
  const user = auth.store.logged.get();
  return user && (
    <Navbar.Collapse id="basic-navbar-nav" className="navbar-crm not-printable">
      <Nav className="me-auto not-printable ps-4">
        {menus.main.map((item) => (
          <Nav.Link onClick={() => { Router.push(item.href); }} className={code === item.code ? 'rounded active' : 'rounded'} key={generator.token()}>
            <span className="badge-icon me-1">{item.icon}</span>
            {!!item.updates && <Badge bg="danger" className="badge-notification rounded-pill">{item.updates}</Badge>}
            <span className="nav-link-label">{item.label}</span>
          </Nav.Link>
        ))}
      </Nav>
    </Navbar.Collapse>
  );
}
